import { StyleSheet } from 'react-native';

import { PALETTE  } from '../../../../constants';

export default StyleSheet.create({
  topSearchResults: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom:10,
    marginTop:20
  },
  text: {
    flex: 1,
  },
  portfolioText: {
    marginLeft: 5,
    marginRight: 5,
    minWidth: 140,
  },
});
